import React, { useState, useEffect, useMemo, useCallback } from "react";
import styled from "styled-components";
import { useFilters, useSortBy, usePagination } from "react-table";
import {
  getMovimientosFull,
  deleteMovimiento,
  putMovimiento,
  getMovimientoById,
} from "../helpers/rutaMovimientos";
import ModalFormMovimiento from "../components/ModalFormMovimiento";
import Table from "./TableContainer";
import "../css/tablecomandas.css";

const Styles = styled.div`
  .table-container {
    overflow: auto;
    height: 600px;
    position: relative;
  }

  table {
    border: 1px solid black;
    border-spacing: 0;
    font-size: 13px;
  }

  th,
  td {
    padding: 0.5rem;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
  }

  thead {
    position: sticky;
    top: 0;
    z-index: 50;
  }

  th {
    background-color: #0d6efd;
    color: white;
    position: sticky;
    top: 0;
    z-index: 60;
    text-align: center;
    font-size: 12px;
  }

  td {
    background-color: white;
  }

  .pagination {
    padding: 0.5rem;
    background-color: #778899;
    font-size: 15px;
    font-weight: bold;
  }
`;

const FiltrosBar = styled.div`
  display: grid;
  grid-template-columns:
    120px
    120px
    130px
    minmax(180px, 1.4fr)
    140px
    170px
    105px;

  gap: 10px;

  margin-bottom: 12px;

  padding: 14px;

  border: 1px solid #e2e8f0;
  border-radius: 12px;

  background: #ffffff;

  box-shadow:
    0 3px 14px
    rgba(15, 23, 42, 0.035);

  align-items: end;

  .field {
    display: flex;
    flex-direction: column;

    min-width: 0;
  }

  label {
    margin-bottom: 5px;

    color: #59687d;

    font-size: 10px;
    font-weight: 600;

    white-space: nowrap;
  }

  input,
  select {
    width: 100%;
    height: 34px;

    box-sizing: border-box;

    padding: 0 8px;

    border: 1px solid #d7e0ea;
    border-radius: 7px;

    background: #ffffff;

    color: #24324a;

    font-size: 10.5px;

    outline: none;
  }

  input:focus,
  select:focus {
    border-color: #72c3a2;

    box-shadow:
      0 0 0 2px
      rgba(21, 154, 103, 0.07);
  }

  .mov-fila2 {
    grid-column: 1 / -1;

    display: grid;

    grid-template-columns:
      1fr
      1fr
      1fr
      0.9fr
      auto;

    gap: 10px;

    align-items: end;
  }

  .btns {
    display: flex;

    gap: 6px;

    justify-content: flex-end;
    align-items: end;

    white-space: nowrap;
  }

  .btns button {
    min-width: 110px;
    height: 34px;

    padding: 5px 9px;

    border-radius: 7px;

    font-size: 10px;

    white-space: nowrap;
  }

  .mov-fila3 {
    display: none;
  }

  .btns {
    display: flex;

    gap: 6px;

    justify-content: flex-end;

    align-items: end;
  }

  .btns button {
    min-width: 110px;
    height: 34px;

    padding: 5px 9px;

    border-radius: 7px;

    font-size: 10px;

    white-space: nowrap;
  }

  @media (max-width: 1200px) {
    grid-template-columns:
      repeat(4, minmax(120px, 1fr));

    .mov-fila2 {
      grid-template-columns:
        1fr 1fr;
    }

    .btns {
      grid-column: 1 / -1;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
  }

  @media (max-width: 768px) {
    grid-template-columns:
      1fr 1fr;

    .mov-fila2 {
      grid-template-columns:
        1fr;
    }

    .btns {
      justify-content: flex-start;

      flex-wrap: wrap;
    }
  }

  @media (max-width: 520px) {
    grid-template-columns: 1fr;

    .mov-fila2 {
      grid-template-columns: 1fr;
    }

    .btns {
      flex-direction: column;
    }

    .btns button {
      width: 100%;
    }
  }

`;

const InformeMovimientosHeader = styled.div`
  display: flex;
  align-items: center;

  min-height: 78px;

  margin-bottom: 12px;

  padding: 14px 18px;

  border: 1px solid #cfe9de;
  border-radius: 14px;

  background:
    linear-gradient(
      120deg,
      #ffffff 0%,
      #f7fcfa 65%,
      #ebf8f2 100%
    );

  box-shadow:
    0 3px 14px
    rgba(15, 23, 42, 0.035);

  .header-icon {
    width: 46px;
    height: 46px;

    flex: 0 0 46px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 13px;

    border-radius: 11px;

    background: #e5f7ef;

    color: #159a67;

    font-size: 19px;
  }

  .header-text span {
    display: block;

    margin-bottom: 2px;

    color: #159a67;

    font-size: 9px;
    font-weight: 700;

    letter-spacing: 1.7px;
  }

  .header-text h3 {
    margin: 0 0 3px 0;

    color: #18243a;

    font-size: 20px;
    font-weight: 700;
  }

  .header-text p {
    margin: 0;

    color: #748196;

    font-size: 10px;
  }

  @media (max-width: 768px) {
    padding: 12px;

    .header-icon {
      width: 42px;
      height: 42px;

      flex-basis: 42px;
    }

    .header-text h3 {
      font-size: 17px;
    }
  }
`;

/* ---------- utils ---------- */
function getYMD(value) {
  if (!value) return "";

  if (value?.$date) value = value.$date;

  if (typeof value === "string") {
    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[1]}-${m[2]}-${m[3]}`;
  }

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";

  return new Intl.DateTimeFormat("sv-SE", {
    timeZone: "UTC",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(d);
}

function formatFechaYMDToES(ymd) {
  if (!ymd) return "";
  const [y, m, d] = ymd.split("-");
  if (!y || !m || !d) return "";
  return `${d}/${m}/${y}`;
}

function toStartOfDay(dateStr) {
  return getYMD(dateStr);
}

function toEndOfDay(dateStr) {
  return getYMD(dateStr);
}

function safeGet(obj, path) {
  try {
    return (
      path
        .split(".")
        .reduce((o, k) => (o && o[k] != null ? o[k] : ""), obj) ?? ""
    );
  } catch {
    return "";
  }
}

function norm(v) {
  return (v ?? "")
    .toString()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

/* ---------- helper caja / cuenta bancaria ---------- */
function getCajaTexto(row) {
  const c = row?.caja;
  if (isObj(c)) {
    return c.descripcion || c.nombre || c.codcaj || c.caja || "CAJA";
  }

  const cb = row?.cuentaBancaria;
  if (isObj(cb)) {
    return (
      [cb.alias, cb.banco, cb.numero].filter(Boolean).join(" - ") ||
      cb.cbu ||
      cb.cvu ||
      "CUENTA BANCARIA"
    );
  }

  // mientras no se hidrata todavía
  if (typeof c === "string" && c) return "EFECTIVO";
  if (typeof cb === "string" && cb) return "TRANSFERENCIA";

  return "";
}

function getUsuarioTexto(row) {
  const usuario = row?.usuario;

  if (!isObj(usuario)) return "";

  return (
    usuario.nombres ||
    usuario.nombre ||
    usuario.name ||
    usuario.usuario ||
    usuario.email ||
    usuario.correo ||
    ""
  );
}

/* =======================================================
   Componente
======================================================= */
export default function AppMovimientoReactTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [movimientoEdit, setMovimientoEdit] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // ---- Filtros controlados ----
  const [filtros, setFiltros] = useState({
    desde: "",
    hasta: "",
    tipo: "",
    descripcion: "",
    gasto: "",
    caja: "",
    nroviaje: "",
    camion: "",
    chofer: "",
    usuario: "",
    libre: "",
  });

  // const puedeEditarBorrar = emailUsuario === "pablonsaya@hotmail.com";

  const setF = (k, v) => setFiltros((prev) => ({ ...prev, [k]: v }));

  /* ---------- HIDRATACIÓN RÁPIDA (solo visibles) ---------- */
  const VISIBLE_TO_ENRICH = 60;
  const CONCURRENCY = 16;
  const KEYS = ["caja", "cuentaBancaria", "gasto", "comanda", "camion", "chofer","usuario",];

  const needsEnrich = (m) => KEYS.some((k) => m?.[k] && typeof m[k] === "string");

  const enrichFirstPage = useCallback(async (list) => {
    const target = (list || []).slice(0, VISIBLE_TO_ENRICH).filter(needsEnrich);
    if (target.length === 0) return;

    let idx = 0;
    const updated = [...list];

    const worker = async () => {
      while (idx < target.length) {
        const current = target[idx++];
        try {
          const resp = await getMovimientoById(current._id);
          const det = resp?.movimiento;
          if (det) {
            const i = updated.findIndex((x) => x._id === current._id);
            if (i >= 0) {
              const merged = { ...updated[i] };
              KEYS.forEach((k) => {
                if (det[k]) merged[k] = det[k];
              });
              updated[i] = merged;
            }
          }
        } catch {}
      }
    };

    await Promise.all(
      Array.from({ length: Math.min(CONCURRENCY, target.length) }, () => worker())
    );

    setData(updated);
  }, []);

  /* ---------- Fetch ---------- */
  const fetchData = useCallback(async () => {
    setLoading(true);

    const resp = await getMovimientosFull();

    if (!resp?.ok) {
      console.error(resp?.error || "Error al obtener movimientos");
      setData([]);
      setLoading(false);
      return;
    }

    const list = resp.movimientos || [];
    setData(list);
    enrichFirstPage(list);
    setLoading(false);
  }, [enrichFirstPage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  /* ---------- Acciones ---------- */
  const handleClose = () => {
    setShowModal(false);
    setMovimientoEdit(null);
    fetchData();
  };

  const borrar = useCallback(
    async (mongoId, codmov) => {
      const ok = window.confirm(
        `¿Está seguro que desea eliminar el movimiento${
          codmov ? ` ${codmov}` : ""
        }?\n\nEsta acción realizará un borrado lógico del registro.`
      );
      if (!ok) return;

      const resp = await deleteMovimiento(mongoId);

      if (!resp?.ok) {
        alert(resp?.msg || "No se pudo eliminar el movimiento.");
        return;
      }

      fetchData();
    },
    [fetchData]
  );

  const editar = useCallback(
    async (id, values) => {
      await putMovimiento(id, values);
      setData((prev) => prev.map((m) => (m._id === id ? { ...m, ...values } : m)));
      fetchData();
    },
    [fetchData]
  );

  /* ---------- Filtrado en memoria ---------- */
  const dataFiltrada = useMemo(() => {
    const dDesde = toStartOfDay(filtros.desde);
    const dHasta = toEndOfDay(filtros.hasta);

    return (data || []).filter((r) => {
      const f = getYMD(r?.fecha);
      if (dDesde && (!f || f < dDesde)) return false;
      if (dHasta && (!f || f > dHasta)) return false;

      if (filtros.tipo && !norm(r?.tipo).includes(norm(filtros.tipo))) return false;
      if (filtros.descripcion && !norm(r?.descripcion).includes(norm(filtros.descripcion)))
        return false;

      // Gasto
      if (filtros.gasto) {
        const g = r?.gasto;
        const gastoTxt = isObj(g)
          ? g.gasto || g.nombre || g.descripcion || g.categoria || g.rubro || ""
          : "";
        if (!norm(gastoTxt).includes(norm(filtros.gasto))) return false;
      }

      // Caja / Cuenta bancaria
      if (filtros.caja) {
        const cajaTxt = getCajaTexto(r);
        if (!norm(cajaTxt).includes(norm(filtros.caja))) return false;
      }

      // Viaje
      if (filtros.nroviaje) {
        const v = r?.comanda;
        const nv = isObj(v) ? v.nroviaje || v.codcom || "" : "";
        if (!norm(nv).includes(norm(filtros.nroviaje))) return false;
      }

      // Camión
      if (filtros.camion) {
        const cm = r?.camion;
        const camionTxt = isObj(cm) ? cm.camion || cm.patente || "" : "";
        if (!norm(camionTxt).includes(norm(filtros.camion))) return false;
      }

      // Chofer
      if (filtros.chofer) {
        const ch = r?.chofer;
        const choferTxt = isObj(ch) ? ch.nombre || "" : "";
        if (!norm(choferTxt).includes(norm(filtros.chofer))) return false;
      }

      if (
          filtros.usuario &&
          !norm(getUsuarioTexto(r)).includes(norm(filtros.usuario))
        ) {
          return false;
        }

      if (filtros.libre && !norm(r?.libre).includes(norm(filtros.libre))) return false;

      return true;
    });
  }, [data, filtros]);

  const limpiarFiltros = () =>
    setFiltros({
      desde: "",
      hasta: "",
      tipo: "",
      descripcion: "",
      gasto: "",
      caja: "",
      nroviaje: "",
      camion: "",
      chofer: "",
      usuario: "",
      libre: "",
    });

  const quickHoy = () => {
    const hoy = new Date();
    const y = hoy.getFullYear();
    const m = String(hoy.getMonth() + 1).padStart(2, "0");
    const d = String(hoy.getDate()).padStart(2, "0");
    const iso = `${y}-${m}-${d}`;
    setF("desde", iso);
    setF("hasta", iso);
  };

  const quickUltimos7 = () => {
    const hoy = new Date();
    const d7 = new Date(hoy);
    d7.setDate(hoy.getDate() - 6);

    const toISO = (dt) =>
      `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(
        dt.getDate()
      ).padStart(2, "0")}`;

    setF("desde", toISO(d7));
    setF("hasta", toISO(hoy));
  };

const USUARIOS_HABILITADOS_ACCIONES = [
  "pablonsaya@hotmail.com",
  "pablosaya@hotmail.com", // lo dejo por si el mail real está sin la N
];

const NOMBRES_HABILITADOS_ACCIONES = [
  "pablo",
  "pablo nsaya",
  "pablo saya",
];

const normalizarTexto = (v) =>
  String(v || "")
    .toLowerCase()
    .trim();

const buscarEmailEnObjeto = (obj) => {
  if (!obj || typeof obj !== "object") return "";

  const posiblesCampos = [
    "email",
    "correo",
    "mail",
    "username",
    "usuario",
    "user",
  ];

  for (const campo of posiblesCampos) {
    const valor = obj?.[campo];

    if (
      typeof valor === "string" &&
      valor.includes("@") &&
      valor.includes(".")
    ) {
      return normalizarTexto(valor);
    }
  }

  for (const key of Object.keys(obj)) {
    const valor = obj[key];

    if (valor && typeof valor === "object") {
      const encontrado = buscarEmailEnObjeto(valor);
      if (encontrado) return encontrado;
    }

    if (
      typeof valor === "string" &&
      valor.includes("@") &&
      valor.includes(".")
    ) {
      return normalizarTexto(valor);
    }
  }

  return "";
};

const buscarNombreEnObjeto = (obj) => {
  if (!obj || typeof obj !== "object") return "";

  const posiblesCampos = [
    "nombre",
    "nombres",
    "name",
    "usuario",
    "username",
    "displayName",
  ];

  for (const campo of posiblesCampos) {
    const valor = obj?.[campo];

    if (
      typeof valor === "string" &&
      valor.trim() &&
      !valor.includes("@")
    ) {
      return normalizarTexto(valor);
    }
  }

  for (const key of Object.keys(obj)) {
    const valor = obj[key];

    if (valor && typeof valor === "object") {
      const encontrado = buscarNombreEnObjeto(valor);
      if (encontrado) return encontrado;
    }
  }

  return "";
};

const decodeJwtPayload = (token) => {
  try {
    if (!token || token.split(".").length !== 3) return null;

    const base64Url = token.split(".")[1];
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");

    while (base64.length % 4) {
      base64 += "=";
    }

    return JSON.parse(atob(base64));
  } catch (error) {
    return null;
  }
};

const getUsuarioActualPermisos = () => {
  let email = "";
  let nombre = "";

  try {
    // 1) Recorre TODO el localStorage buscando email o nombre
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const raw = localStorage.getItem(key);

      if (!raw) continue;

      // Si el valor directo es email
      if (raw.includes("@") && raw.includes(".")) {
        email = normalizarTexto(raw);
      }

      // Si el valor directo es nombre
      if (!nombre && raw && !raw.includes("{") && !raw.includes("@")) {
        const texto = normalizarTexto(raw);

        if (texto === "pablo" || texto.includes("pablo")) {
          nombre = texto;
        }
      }

      // Si es JSON
      try {
        const obj = JSON.parse(raw);

        const emailObj = buscarEmailEnObjeto(obj);
        const nombreObj = buscarNombreEnObjeto(obj);

        if (emailObj) email = emailObj;
        if (nombreObj) nombre = nombreObj;
      } catch {
        // no era JSON, seguimos
      }
    }

    // 2) Revisa token JWT
    const token = localStorage.getItem("token");

    const payload = decodeJwtPayload(token);

    if (payload) {
      const emailToken = buscarEmailEnObjeto(payload);
      const nombreToken = buscarNombreEnObjeto(payload);

      if (emailToken) email = emailToken;
      if (nombreToken) nombre = nombreToken;
    }

    return { email, nombre };
  } catch (error) {
    console.error("Error leyendo usuario actual:", error);
    return { email: "", nombre: "" };
  }
};

const usuarioActualPermisos = getUsuarioActualPermisos();

const puedeEditarBorrar =
  USUARIOS_HABILITADOS_ACCIONES.includes(usuarioActualPermisos.email) ||
  NOMBRES_HABILITADOS_ACCIONES.includes(usuarioActualPermisos.nombre);

// Dejalo temporalmente para verificar qué está leyendo.
// Después lo podés borrar.
console.log("USUARIO ACTUAL PERMISOS:", usuarioActualPermisos);
console.log("PUEDE EDITAR/BORRAR:", puedeEditarBorrar);

  /* ---------- Columnas ---------- */
  const columns = useMemo(
    () => [
      ...(puedeEditarBorrar
        ? [
            {
              id: "editar",
              Header: "Edita",
              accessor: "_id",
              width: 50,
              Cell: ({ row }) => (
                <button
                  className="action-btn action-btn--edit"
                  title="Editar"
                  onClick={() => {
                    setMovimientoEdit(row.original);
                    setShowModal(true);
                  }}
                >
                  <i className="fa fa-pencil" aria-hidden="true" />
                </button>
              ),
            },
            {
              id: "eliminar",
              Header: "🗑️",
              accessor: "_id",
              width: 50,
              Cell: ({ row }) => (
                <button
                  className="action-btn action-btn--del"
                  title="Eliminar"
                  onClick={() => borrar(row.original._id, row.original.codmov)}
                >
                  <i
                    className="fa fa-trash-o"
                    aria-hidden="true"
                    style={{ color: "#dc3545" }}
                  />
                </button>
              ),
            },
          ]
        : []),

      { Header: "Nro", accessor: "codmov", width: 60 },

      {
        Header: "Fecha",
        accessor: (row) => getYMD(row.fecha),
        id: "fecha",
        width: 120,
        Cell: ({ value }) => formatFechaYMDToES(value),
      },

      { Header: "Tipo", accessor: "tipo", width: 80 },

      {
        Header: "Monto Ingreso",
        accessor: (row) =>
          row.tipo?.toLowerCase() === "ingreso" ? Number(row.monto) || 0 : 0,
        id: "montoIngreso",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>
            {value
              ? value.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })
              : ""}
          </div>
        ),
        Footer: (info) => {
          const total = info.rows.reduce(
            (sum, row) => sum + (row.values.montoIngreso || 0),
            0
          );

          return (
            <div
              style={{
                textAlign: "right",
                color: "green",
                fontWeight: "bold",
              }}
            >
              {total.toLocaleString("es-AR", {
                style: "currency",
                currency: "ARS",
              })}
            </div>
          );
        },
      },

      {
        Header: "Monto Egreso",
        accessor: (row) =>
          row.tipo?.toLowerCase() === "egreso" ? Number(row.monto) || 0 : 0,
        id: "montoEgreso",
        width: 120,
        Cell: ({ value }) => (
          <div style={{ textAlign: "right" }}>
            {value
              ? value.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })
              : ""}
          </div>
        ),
        Footer: (info) => {
          const totalE = info.rows.reduce(
            (sum, row) => sum + (row.values.montoEgreso || 0),
            0
          );

          const totalI = info.rows.reduce(
            (sum, row) => sum + (row.values.montoIngreso || 0),
            0
          );

          const saldo = totalI - totalE;

          return (
            <div style={{ textAlign: "right" }}>
              <div style={{ color: "red", fontWeight: "bold" }}>
                {totalE.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </div>

              <div style={{ fontWeight: "bold", color: "blue" }}>
                SALDO:{" "}
                {saldo.toLocaleString("es-AR", {
                  style: "currency",
                  currency: "ARS",
                })}
              </div>
            </div>
          );
        },
      },

      { Header: "Descripción", accessor: "descripcion", width: 230 },

      {
        Header: "Gasto",
        accessor: (row) => {
          const g = row?.gasto;

          if (isObj(g)) {
            return (
              g.gasto ||
              g.nombre ||
              g.descripcion ||
              g.categoria ||
              g.rubro ||
              ""
            );
          }

          return "";
        },
        id: "gastoTexto",
        width: 150,
      },

      {
        Header: "Caja",
        accessor: (row) => getCajaTexto(row),
        id: "cajaTexto",
        width: 230,
      },

      {
        Header: "Nro Viaje",
        accessor: (row) => {
          const v = row?.comanda;

          if (isObj(v)) return v.nroviaje || v.codcom || "";

          return "";
        },
        id: "nroViajeTexto",
        width: 90,
      },

      {
        Header: "Camión",
        accessor: (row) => {
          const cm = row?.camion;

          if (isObj(cm)) return cm.camion || cm.patente || "";

          return "";
        },
        id: "camionTexto",
        width: 120,
      },

      {
        Header: "Chofer",
        accessor: (row) => {
          const ch = row?.chofer;

          if (isObj(ch)) return ch.nombre || "";

          return "";
        },
        id: "choferTexto",
        width: 150,
      },

      { Header: "Libre", accessor: "libre", width: 300 },

      {
        Header: "Usuario",
        accessor: (row) => getUsuarioTexto(row),
        id: "usuarioTexto",
        width: 150,
      },
    ],
    [borrar, puedeEditarBorrar]
  );

  return (
    <div className="container mt-4">

      <InformeMovimientosHeader>
        <div className="header-icon">
          <i
            className="fa fa-exchange"
            aria-hidden="true"
          />
        </div>

        <div className="header-text">
          <span>
            INFORMES · TESORERÍA
          </span>

          <h3>
            Listado de Movimientos
          </h3>

          <p>
            Consulta de ingresos, egresos,
            cajas, viajes, gastos y usuarios.
          </p>
        </div>
      </InformeMovimientosHeader>

      <FiltrosBar>

        <div className="field">
          <label>Fecha desde</label>

          <input
            type="date"
            value={filtros.desde}
            onChange={(e) =>
              setF("desde", e.target.value)
            }
          />
        </div>

        <div className="field">
          <label>Fecha hasta</label>

          <input
            type="date"
            value={filtros.hasta}
            onChange={(e) =>
              setF("hasta", e.target.value)
            }
          />
        </div>

        <div className="field">
          <label>Tipo</label>

          <input
            placeholder="Ingreso / Egreso"
            value={filtros.tipo}
            onChange={(e) =>
              setF("tipo", e.target.value)
            }
          />
        </div>

        <div className="field">
          <label>Descripción</label>

          <input
            value={filtros.descripcion}
            onChange={(e) =>
              setF("descripcion", e.target.value)
            }
          />
        </div>

        <div className="field">
          <label>Gasto</label>

          <input
            value={filtros.gasto}
            onChange={(e) =>
              setF("gasto", e.target.value)
            }
          />
        </div>

        <div className="field">
          <label>Caja</label>

          <input
            value={filtros.caja}
            onChange={(e) =>
              setF("caja", e.target.value)
            }
          />
        </div>

        <div className="field">
          <label>Nro Viaje</label>

          <input
            value={filtros.nroviaje}
            onChange={(e) =>
              setF("nroviaje", e.target.value)
            }
          />
        </div>

        <div className="mov-fila2">

          <div className="field">
            <label>Camión</label>

            <input
              value={filtros.camion}
              onChange={(e) =>
                setF("camion", e.target.value)
              }
            />
          </div>

          <div className="field">
            <label>Chofer</label>

            <input
              value={filtros.chofer}
              onChange={(e) =>
                setF("chofer", e.target.value)
              }
            />
          </div>

          <div className="field">
            <label>Usuario</label>

            <input
              value={filtros.usuario}
              onChange={(e) =>
                setF("usuario", e.target.value)
              }
            />
          </div>

          <div className="field">
            <label>Libre</label>

            <input
              value={filtros.libre}
              onChange={(e) =>
                setF("libre", e.target.value)
              }
            />
          </div>

          <div className="btns">

            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={quickHoy}
            >
              Hoy
            </button>

            <button
              type="button"
              className="btn btn-outline-success btn-sm"
              onClick={quickUltimos7}
            >
              Últimos 7 días
            </button>

            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={limpiarFiltros}
            >
              Limpiar
            </button>

          </div>

        </div>


      </FiltrosBar>

      <Styles>
        <div className="table-container">
          <Table
            columns={columns}
            data={dataFiltrada}
            loading={loading}
            plugins={[useFilters, useSortBy, usePagination]}
          />
        </div>
      </Styles>

      {movimientoEdit && (
        <ModalFormMovimiento
          show={showModal}
          handleClose={handleClose}
          movimiento={movimientoEdit}
          onSave={editar}
        />
      )}
    </div>
  );
}